import React from 'react';
import DataListingsSection from './data-listings-section';
import styles from './index.module.scss';
import SubjectsSection from './subjects-section';
import { EditReviewDto } from '@interfaces-clean/reviews.interface';
import { StudyMemberDto } from '@interfaces-clean/study-member.interface';
import { ReviewSubjectDto } from '@interfaces-clean/subject-monitoring/subject-review';
import ReviewPlanDetails from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/review-plan-details';
import { ReviewPlanAPI } from '@apis/bff-api/study/review-plans';

type Props = {
    isHalfScreen: boolean;
    studyRef: string;
    review: EditReviewDto;
    reviewSubjects: ReviewSubjectDto[];
    smStudyMembers: StudyMemberDto[];
    sessionId: string;
};

const SMActiveReviewTabReviewPlanTab = ({
    isHalfScreen,
    studyRef,
    review,
    reviewSubjects,
    smStudyMembers,
    sessionId,
}: Props) => {
    const { data: reviewPlanDetail } = ReviewPlanAPI.useGetById(studyRef, review.reviewPlanId ?? null);
    const reviewSubject = reviewPlanDetail?.reviewSubject ?? false;

    return (
        <div className={styles.grid} data-is-half-screen={isHalfScreen}>
            <ReviewPlanDetails canEdit review={review} smStudyMembers={smStudyMembers} studyRef={studyRef} />

            <DataListingsSection studyRef={studyRef} review={review} />

            <SubjectsSection
                studyRef={studyRef}
                review={review}
                reviewSubjects={reviewSubjects}
                reviewSubject={reviewSubject}
                sessionId={sessionId}
            />
        </div>
    );
};

export default SMActiveReviewTabReviewPlanTab;
